import React, { useState, useEffect, useCallback } from 'react';
import {
    Box, Typography, CircularProgress, Chip,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from '@mui/material';
import { solicitudesPagoExpedienteJWT } from '../../api/endpoints';

const estadoColor = {
    '-1': 'default',
    '0': 'warning',
    '1': 'success',
    '2': 'info',
    '3': 'default',
    '4': 'primary',
};

const formatMonto = (value) => {
    if (value == null) return '-';
    return `$ ${Number(value).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

function SolicitudesPagoTab({ idExpediente }) {
    const [solicitudes, setSolicitudes] = useState([]);
    const [loading, setLoading] = useState(true);

    const cargar = useCallback(async () => {
        try {
            const resp = await solicitudesPagoExpedienteJWT(idExpediente);
            if (resp?.ok) setSolicitudes(resp.solicitudes || []);
        } catch { }
        finally { setLoading(false); }
    }, [idExpediente]);

    useEffect(() => { cargar(); }, [cargar]);

    if (loading) {
        return <Box display="flex" justifyContent="center" py={6}><CircularProgress size={32} /></Box>;
    }

    if (solicitudes.length === 0) {
        return (
            <Box textAlign="center" py={6}>
                <Typography variant="body1" sx={{ color: '#bbb' }}>
                    No hay solicitudes de pago vinculadas a este expediente
                </Typography>
            </Box>
        );
    }

    const totalHonorarios = solicitudes.reduce((sum, s) => sum + (Number(s.Honorarios) || 0), 0);
    const totalCertificados = solicitudes.reduce((sum, s) => sum + (Number(s.Certificados) || 0), 0);

    return (
        <Box>
            {/* Resumen */}
            <Box display="flex" gap={2} mb={2} flexWrap="wrap">
                <Chip
                    label={`${solicitudes.length} solicitud${solicitudes.length !== 1 ? 'es' : ''}`}
                    size="small" variant="outlined"
                />
                <Chip
                    label={`${totalCertificados} certificado${totalCertificados !== 1 ? 's' : ''}`}
                    size="small" variant="outlined" color="info"
                />
                <Chip
                    label={`Total: ${formatMonto(totalHonorarios)}`}
                    size="small" variant="outlined" color="success"
                />
            </Box>

            <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                    <TableHead>
                        <TableRow sx={{ '& th': { fontWeight: 600, fontSize: '0.82rem', backgroundColor: '#fafafa' } }}>
                            <TableCell>Nº Sol.</TableCell>
                            <TableCell>Fecha</TableCell>
                            <TableCell>Profesional</TableCell>
                            <TableCell>Matrícula</TableCell>
                            <TableCell align="center">Cert.</TableCell>
                            <TableCell align="right">Honorarios</TableCell>
                            <TableCell>Estado</TableCell>
                            <TableCell>Fecha Pago</TableCell>
                            <TableCell>Comprobante</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {solicitudes.map((s) => (
                            <TableRow
                                key={s.Id}
                                hover
                                onClick={() => window.open('/honorarios', '_blank')}
                                sx={{
                                    cursor: 'pointer',
                                    '& td': { fontSize: '0.82rem' },
                                }}
                            >
                                <TableCell>{s.Id}</TableCell>
                                <TableCell>{s.Fecha}</TableCell>
                                <TableCell>{s.Profesional}</TableCell>
                                <TableCell>{s.Matricula}</TableCell>
                                <TableCell align="center">{s.Certificados}</TableCell>
                                <TableCell align="right">{formatMonto(s.Honorarios)}</TableCell>
                                <TableCell>
                                    <Chip
                                        label={s.Estado}
                                        color={estadoColor[String(s.Id_Estado)] || 'default'}
                                        size="small"
                                        variant="outlined"
                                    />
                                </TableCell>
                                <TableCell>{s.Fecha_Pago || '-'}</TableCell>
                                <TableCell>{s.Comprobante || '-'}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default SolicitudesPagoTab;
